var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('partner-notice-form',{attrs:{"title":"공지사항 수정","is-modification":true,"initial-notice-form":_vm.initialNoticeForm},on:{"upsert-notice":_vm.modifyNotice,"cancel":function($event){return _vm.onNegativeClick()}}})}
var staticRenderFns = []

export { render, staticRenderFns }